export class Header {

    constructor(){
        this.$header = $('.c-header');
        this.lastPost = 0;

        /* istanbul ignore next */
        window.addEventListener('scroll', () => this.checkScroll());
    }

    /**
     * Checks the user's scroll direction and adjusts the header class accordingly
     */
    checkScroll() {
        if ($(window).width() < 960) {
            this.$header.removeClass('c-header--compact');
            return false;
        }

        let position = $(window).scrollTop();
        if (position > this.lastPost){
            this.$header.addClass('c-header--compact');
        } else {
            this.$header.removeClass('c-header--compact');
        }
        this.lastPost = position ;
    }

}
